<template>
  <DownloadButton :config="config" :labels="labels"/>
</template>

<script>
import DownloadButton from "../../components/DownloadButton/DownloadButton.vue";

export default {
  name: "app",
  components: {
    DownloadButton
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config),
      labels: JSON.parse(this.$options._parentVnode.data.props.labels)
    };
  }
};
</script>
